exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**  rel=\"stylesheet/scss\" lang=\"scss\"*/\n/** backgroud */\n/** border */\n/** table */\n/* Popover\n-------------------------- */\n/* Dialog\n-------------------------- */\n[data-v-9aae5f5c]:export {\n  xrColorPrimary: #2362FB;\n}\n.el-container[data-v-9aae5f5c] {\n  min-height: 0;\n  height: 100%;\n}\n.nav-container[data-v-9aae5f5c] {\n  padding: 0;\n  -webkit-box-shadow: 0px 1px 2px #dbdbdb;\n          box-shadow: 0px 1px 2px #dbdbdb;\n  z-index: 100;\n  min-width: 1200px;\n}\n", ""]);

// exports
